import { Entity } from "@backstage/catalog-model";
import {
	createPlugin,
	createRoutableExtension,
} from "@backstage/core-plugin-api";

import { rootRouteRef } from "./routes";

export const DBT_BUCKET_ANNOTATION = "dbtdoc-bucket";

export const isDBTAvailable = (entity: Entity): boolean =>
	Boolean(entity.metadata.annotations?.[DBT_BUCKET_ANNOTATION]);

export const dbtPlugin = createPlugin({
	id: "dbt",
	routes: {
		root: rootRouteRef,
	},
});

export const DbtPage = dbtPlugin.provide(
	createRoutableExtension({
		name: "DbtPage",
		component: () =>
			import("./components/DbtComponent").then((m) => m.DbtComponent),
		mountPoint: rootRouteRef,
	}),
);
